import React from 'react';
import '../styles/pages/AboutGyaniraj.css';

const AboutGyaniraj = () => {
  const milestones = [
    { year: '2013', title: 'Company Founded', description: 'Gyaniraj Offset established in Chhatarpur, M.P.' },
    { year: '2015', title: 'Technology Upgrade', description: 'Introduced state-of-the-art printing technology' },
    { year: '2018', title: 'Business Expansion', description: 'Expanded services across Madhya Pradesh' },
    { year: '2020', title: 'Digital Integration', description: 'Added LED signage and CNC cutting services' },
    { year: '2023', title: 'Pan-India Services', description: 'Extended services across India' }
  ];

  const values = [
    {
      title: 'Quality Excellence',
      description: 'We maintain the highest standards in printing quality, using premium materials and state-of-the-art technology.',
      icon: '🏆'
    },
    {
      title: 'Customer First',
      description: 'Every project is handled with personalized attention to ensure complete customer satisfaction.',
      icon: '👥'
    },
    {
      title: 'Innovation',
      description: 'Continuously adopting latest printing technologies and techniques to stay ahead in the industry.',
      icon: '💡'
    },
    {
      title: 'Timely Delivery',
      description: 'We understand the importance of deadlines and ensure timely delivery without compromising quality.',
      icon: '⏰'
    }
  ];

  const team = [
    {
      name: 'Deepak Chaurasiya',
      role: 'Proprietor',
      experience: '10+ years',
      expertise: 'Printing Technology & Business Strategy'
    },
    {
      name: 'Design Team',
      role: 'Creative Department',
      experience: '5+ years',
      expertise: 'Graphic Design & Creative Solutions'
    },
    {
      name: 'Technical Team',
      role: 'Production Department',
      experience: '8+ years',
      expertise: 'Printing Operations & Quality Control'
    }
  ];

  return (
    <div className="about-gyaniraj-page">
      <div className="about-hero">
        <div className="container">
          <h1>About Gyaniraj Offset</h1>
          <p>India's fastest growing printing production house since 2013</p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <section className="company-overview">
            <div className="overview-grid">
              <div className="overview-text">
                <h2>Our Story</h2>
                <p>
                  Gyaniraj Offset was established in 2013 with a vision to provide premium quality printing solutions 
                  across India. What started as a small printing shop in Chhatarpur, Madhya Pradesh, has now grown 
                  into one of the fastest-growing printing production houses in the country.
                </p>
                <p>
                  With over a decade of experience, we specialize in providing comprehensive printing solutions 
                  including flex printing, eco-solvent printing, HP latex printing, and state-of-the-art signage 
                  services. Our commitment to quality and customer satisfaction has made us the preferred choice 
                  for businesses across India.
                </p>
              </div>
              <div className="overview-stats">
                <div className="stat-item">
                  <h3>10+</h3>
                  <p>Years of Experience</p>
                </div>
                <div className="stat-item">
                  <h3>1000+</h3>
                  <p>Happy Clients</p>
                </div>
                <div className="stat-item">
                  <h3>50+</h3>
                  <p>Services Offered</p>
                </div>
                <div className="stat-item">
                  <h3>24/7</h3>
                  <p>Customer Support</p>
                </div>
              </div>
            </div>
          </section>

          <section className="mission-vision">
            <div className="mission-vision-grid">
              <div className="mission-card">
                <h2>Our Mission</h2>
                <p>
                  To provide the best quality printing services with exceptional customer service, 
                  leveraging cutting-edge technology and innovative solutions to meet every client's 
                  unique requirements.
                </p>
              </div>
              <div className="vision-card">
                <h2>Our Vision</h2>
                <p>
                  To become India's most trusted printing partner by consistently delivering 
                  superior quality products and services that exceed customer expectations.
                </p>
              </div>
            </div>
          </section>

          <section className="values-section">
            <h2>Our Core Values</h2>
            <div className="values-grid">
              {values.map((value, index) => (
                <div key={index} className="value-card">
                  <div className="value-icon">{value.icon}</div>
                  <h3>{value.title}</h3>
                  <p>{value.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="journey-section">
            <h2>Our Journey</h2>
            <div className="timeline">
              {milestones.map((milestone, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-year">{milestone.year}</div>
                  <div className="timeline-content">
                    <h3>{milestone.title}</h3>
                    <p>{milestone.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="team-section">
            <h2>Our Team</h2>
            <div className="team-grid">
              {team.map((member, index) => (
                <div key={index} className="team-card">
                  <h3>{member.name}</h3>
                  <p className="role">{member.role}</p>
                  <p className="experience">{member.experience}</p>
                  <p className="expertise">{member.expertise}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="location-section">
            <h2>Our Location</h2>
            <div className="location-card">
              <h3>Gyaniraj Offset</h3>
              <p>
                Infront of Govt. B.ed College,<br />
                near Chhatrasal Chowraha,<br />
                District Hospital Shop No. 19,<br />
                Chhatarpur (M.P.) 471001
              </p>
              <div className="contact-info">
                <p><strong>Phone:</strong> 9993143569</p>
                <p><strong>Email:</strong> gyanirajoffset1@gmail.com</p>
                <p><strong>Hours:</strong> 10:00 AM to 9:00 PM</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutGyaniraj;
